import { Component, Input, OnInit } from '@angular/core';
import { from } from 'rxjs';
import { SchemaField, Document } from '../../../store/models/document.model';
import { DynamicColumn } from '../dynamic-column';

@Component({
    selector: 'topo-auto-increment-column',
    templateUrl: './auto-increment-column.component.html',
    styleUrls: ['./auto-increment-column.component.scss'],
    standalone: false
})
export class AutoIncrementColumnComponent implements OnInit, DynamicColumn {
  @Input() field: SchemaField;
  @Input() document: Document;

  constructor() {}

  ngOnInit(): void {}

  get fieldValue(): string {
    return this.document?.[this.field.systemName];
  }

  get format(): string {
    return 'FORMAT_TEXT_SINGLELINE';
  }
}
